var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddtoCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3712 14.6289C65.8659 -4.87631 34.1342 -4.87631 14.6289 14.6289C-4.87631 34.1299 -4.87631 65.87 14.6289 85.3712C24.3795 95.1258 37.1897 99.9991 50 99.9991C62.8102 99.9991 75.6163 95.1258 85.371 85.3712C104.876 65.87 104.876 34.1299 85.3712 14.6289ZM77.9592 36.2725L48.7787 65.4532C47.9658 66.2661 46.8987 66.6747 45.8314 66.6747C44.7642 66.6747 43.6969 66.2661 42.884 65.4532L26.2095 48.7787C24.5796 47.1488 24.5796 44.5141 26.2095 42.8842C27.8394 41.2544 30.474 41.2544 32.1039 42.8842L45.8314 56.6117L72.0648 30.3783C73.6947 28.7484 76.3294 28.7484 77.9592 30.3783C79.5891 32.0079 79.5891 34.6426 77.9592 36.2725Z",
    fill: "#7982FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtoCartIcon);
export default __webpack_public_path__ + "static/media/AddtoCartIcon.2bb108cf29199d21b19cd99a59c03627.svg";
export { ForwardRef as ReactComponent };